import React from 'react';
import image4 from '../../../../../images/modules/module-2/5.png';
import image1 from '../../../../../images/modules/module-2/14.png';
import image2 from '../../../../../images/modules/module-2/15.png';
import image3 from '../../../../../images/modules/module-2/16.png';
import image5 from '../../../../../images/modules/module-2/17.png';
import image6 from '../../../../../images/modules/module-2/18.png';
import image7 from '../../../../../images/modules/module-2/19.png';
import image8 from '../../../../../images/modules/module-2/20.png';
import { generateRandomDate } from '../../../utils';
import { NewsCard } from '../NewsCard';
import './index.scss';

export const Awa300x600Content = ({ src }) => {
    return (
        <div className='runup-awa-300x600-wrapper'>
            <div className='runup-awa-300x600'>
                <div className='runup-awa-300x600__widget-wrapper'>
                    <div className='runup-awa-300x600__ad-text'>Advertisement</div>
                    <div className='runup-awa-300x600__widget'>
                        <iframe title='300x600' src={src} width={300} height={600} scrolling='no' />
                    </div>
                </div>
                <div className='runup-awa-300x600__ads'>
                    <div className='runup-awa-300x600__ad'>
                        <NewsCard
                            type='inverse'
                            src={image1}
                            text='Your Marathon Training Diet: The Fuel You Need'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-awa-300x600__ad'>
                        <NewsCard
                            type='inverse'
                            src={image2}
                            text='Choosing the Right Shoes for Every Distance'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-awa-300x600__ad'>
                        <NewsCard
                            type='inverse'
                            src={image3}
                            text='The Science of Pacing: How to Avoid Burning Out Mid-Race'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-awa-300x600__ad'>
                        <NewsCard
                            type='inverse'
                            src={image4}
                            text='Speed Workouts That Actually Work: From Intervals to Fartlek'
                            date={generateRandomDate()}
                        />
                    </div>
                </div>
            </div>
            <div className='runup-awa-300x600__bottom-ads'>
                <div className='runup-awa-300x600__bottom-ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image5}
                        text='Top 5 Running Shoes for Flat Feet in 2025'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-awa-300x600__bottom-ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image6}
                        text='Do You Really Need Carbon Plate Shoes? We Break It Down'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-awa-300x600__bottom-ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image7}
                        text='Cold Weather Running Essentials: Gloves, Layers & Thermal Gear'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-awa-300x600__bottom-ad'>
                    <NewsCard
                        type='vertical-middle'
                        src={image8}
                        text='Running Watches Compared: GPS, Battery Life & Budget Picks'
                        date={generateRandomDate()}
                    />
                </div>
            </div>
        </div>
    );
};
